// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  letter-spacing: 0.5px;
}
body > .light{
  background-color: #f6f6f8;
} 
body > .dark{
  background-color: #021125; 
} 


code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.grey600 {
  color: #2d6bff;
  line-height: 20px;
  height: 56px;
  margin-left: 16px;
  font-size: 14px;
  font-family: Arial;
  font-weight: normal;
  line-height: 20px;
}
.service-request-modal .grey600  {
    width: 454px;
    padding-top: 16px;
    font-size: 14px;
    font-family: Arial;
    font-weight: normal;
    line-height: 20px;
    margin-left: 8px;
}

 .service-request-modal {
  overscroll-behavior: contain;
  font-size: 0.75rem;
}
 .service-request-modal {
  background-color: white;
}
 .service-request-modal--form {
  max-height: 95%;
}
 .service-request-modal--form-title {
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
    color: #021227;
    text-transform: uppercase;
    margin-left: 8px;
}
.service-request-modal--form-title {
  width: 67%;
}
.Edit-label {
  font-size: 10px;
  font-family: Arial;
  font-weight: normal;
  line-height: 18px;
  margin-left: 8px;
  color: #586981;
  margin-top: 16px;
}
.service-request-modal--form.mt-2 {
  margin-top: 16px;
}
.drop-down-container select {
  margin-left: 8px;
  width: 255px;
  font-size: 12px;
  font-family: Arial;
  font-weight: normal;
  padding-top: 10px;
  border-bottom: 1px solid #ccd2d9 !important;
  background-color: #fff;
  cursor: pointer;
  line-height: 1;
  padding-bottom: 12px;
  border: none;
  color: #586981;
  height: 40px;
  outline: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.topshow {
  padding-top: 30px;
}
li{
  list-style-type: none;
}
.Radio-buttons-Elevator {
  cursor: pointer;
  margin: 0;
  padding: 0;
}
#ElevatorB {
  margin-bottom: 16px;
}
#ElevatorB {
  margin-left: -13px;
}
#ListHeight {
  min-height: 0px !important;
}
.radio-service input {
  position: absolute;
  pointer-events: none;
  visibility: hidden;
}
.radio-service input:focus + label {
  background: #eef;
}
.radio-service input:focus + label .checker {
  border-color: #34cb81;
}
.radio-service input:checked + label .checker {
  box-shadow: inset 0 0 0 4px #34cb81;
}
.radio-service label {
  color: #000;
  display: -webkit-box;
  align-items: center;
  border-radius: 14px;
  margin-top: 8px;
  margin-left: 6px;
  font-size: 14px;
  font-family: Arial;
  font-weight: normal;
  line-height: 18px;
  -webkit-text-size-adjust: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.radio-service label:hover .checker {
  box-shadow: inset 0 0 0 4px #34cb81;
}
.radio-service .checker {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 7px;
  margin-top: 2px;
  box-shadow: inset 0 0 0 1px black;
  transition: box-shadow 0.3s ease;
}
.textarea-container {
  position: relative;
}

.character-count-color {
  color: #9fa9b7;
}

.textarea-container {
  position: relative;
}

.radiofit{
  width: 100%;
  height: 24px;
}
option{
  background-color: #041e42;
  color: white;
  cursor: pointer;
  line-height: 1;
  padding: 8px 0 8px 8px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: inherit;
  letter-spacing: 0.5px;

}
.ddlstyle {
  width: 272px;
}
.ddlstyle option{
  width: 272px;
}
.ddlcontainer{

}
select {
  width: 270px;
  margin: 20px;
}
option {
  max-width: 100px;
}
.button:disabled {
  text-transform: uppercase;
  color: #586981;
  font-size: 12px;
  font-family: Arial;
  font-weight: bold;
  line-height: 18px;
  background-color: #9fa9b7;
  border: 2px solid #9fa9b7;
  margin-top: 16px;
}
.btndiv{
  margin-bottom: 0.8rem;
    /* float: right; */
    /* width: 70%; */
    margin-left: 345px;
    height: 100px;
}
.btnreset{
  border: 2px solid #2d6bff;
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
    height: fit-content;
}
.btnsubmit{
  width: 196px;
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
    height: fit-content;
}
.ButtonsBlock {
  margin-top: 32px;
  margin-bottom: 32px;
 /* float: right;
  */
  margin-left: 16px;
}
.ButtonsBlock .button {
  margin-top: 0;
  margin-bottom: 0;
}
.ButtonsBlock .button .button {
  margin-top: 0;
  margin-bottom: 0;
}
#ButtonReset {
  /* width: 260px; */
  /* margin-top: 36px; */
  border: 2px solid #2d6bff;
  font-size: 14px;
  font-family: Arial;
  font-weight: bold;
  line-height: 20px;
  /* height: 40px; */
  margin-top: 16px;
  padding: 5px;
  height: 32px;
}

#BSubmit {
  width: 260px;
  font-size: 14px;
  font-family: Arial;
  font-weight: bold;
  line-height: 20px;
  height: fit-content;
  padding: 5px;
  height: 32px;
  /* margin-bottom: -64px; */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.5);
}
.popup_inner {
  position: absolute;
  left: 25%;
  right: 25%;
  top: 25%;
  bottom: 25%;
  margin: auto;
  background: white;
}
.psrmodal{
  display: block;
    width: auto;
    position: fixed;
    z-index: 8;
    left: 50%;
    top: 50%;
    color: #000;
    max-width: 100%;
    max-height: 98%;
    transform: translate(-50%, -50%);
    background: #f2f2f2;
    box-shadow: 0 0 60px 10px rgb(0 0 0 / 30%);
}
.psrmodal .close       { 
  position: absolute;
    top: 0;
    right: 9px;
    transition: all 200ms;
    font-size: 30px;
    /* font-weight: bold; */
    text-decoration: none;
    color: #787373;
    cursor: pointer;
    z-index: 999;
 }
.psrmodal .close:hover { color: #041e42; }
#modal-root {
  position: relative;
  z-index: 999;
}
.dark .container-fluid{
  background-color: #021125;
}

.light .container-fluid{
  background-color: #f6f6f8;
}

@media screen and (min-width: 576px) and (max-width: 767px) {
.ButtonsBlock {
  margin-top: 32px;
  margin-bottom: 32px;
 /* float: right;
  */
  margin-left: 16px;
}
.ButtonsBlock .button {
  margin-top: 0;
  margin-bottom: 0;
}
.ButtonsBlock .button .button {
  margin-top: 0;
  margin-bottom: 0;
}
#ButtonReset {
  font-size: 14px;
  font-family: Arial;
  font-weight: bold;
  line-height: 20px;
  height: fit-content;
}
#TextDescription {
  margin-left: 19px;
  top: -74px;
}
#BSubmit {
  width: 216px;
  font-size: 14px;
  font-family: Arial;
  font-weight: bold;
  line-height: 20px;
  height: fit-content;
}

#FNote {
  padding-top: 16px;
  padding-left: 16px;
  font-size: 14px;
  font-family: Arial;
  font-weight: normal;
  line-height: 20px;
}

.service-request-modal--form-title {
  font-size: 14px;
  font-family: Arial;
  font-weight: bold;
  line-height: 20px;
  margin-left: 16px;
}
.textarea-container {
  margin-top: 21px;
  margin-left: -7px;
}

}
@media screen and (min-width: 768px) and (max-width: 991px) {


  .ButtonsBlock {
    /* margin-top: 2.8rem; */
    margin-bottom: 36px;
    /* float: right; */
    /* width: 70%; */
    position: relative;
    /* padding-left: -74px; */
    margin-left: 345px;
  }
  #BSubmit {
    width: 216px;
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
    height: fit-content;
  }

  #ButtonReset {
    border: 2px solid #2d6bff;
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
    height: fit-content;
  }

  #FNote {
    padding-top: 16px;
    padding-left: 16px;
    font-size: 14px;
    font-family: Arial;
    font-weight: normal;
    line-height: 20px;
  }

  .service-request-modal--form-title {
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
    margin-left: 10px;
  }

  .Edit-label {
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
}

.character-count {
  width: 61px;
  margin-left: 575px;
  display: flex;
  justify-content: flex-end;
  margin-top: -2px;
  margin-right: 150px;
  margin-bottom: 20px;
}

#TextDescription {
  top: 20px;
  position: absolute !important;;
  left: 10px;
}

.textarea-container {
  margin-top: 21px;
}

#Floor-Design {
  font-size: 14px;
  font-family: Arial;
  font-weight: normal;
  line-height: 20px;
  height: auto;
  min-height: 40px;
  width: 224px;
}

}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .ButtonsBlockFrance {
    margin-top: 32px;
    margin-bottom: 32px;
    /* float: right; */
    width: 100%;
    margin-left: 271px;
  }
  .ButtonsBlock {
    margin-bottom: 32px;
  }
  #ButtonReset {
    border: 2px solid #2d6bff;
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;

    height: fit-content;
  }
  #BSubmit {
    width: 196px;
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
    height: fit-content;
  }

  .service-request-modal--form-title {
    margin-left: 8px;
  }

  #FNote {
    padding-top: 16px;
    padding-left: 8px;
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
  }

  .service-request-modal--form-title {
  }

  .service-request-modal--form-title {
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
  }

  .Edit-label {
    margin-left: 8px;
    font-size: 10px;
  }

  #Floor-Design {
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
    margin-left: 8px;
    height: auto;
    min-height: 40px;
    width: 224px;
  }

}
@media screen and (min-width: 1200px) {

  .ButtonsBlock {
    /* margin-top: .8rem; */
    margin-bottom: 0.8rem;
    /* float: right; */
    /* width: 70%; */
    margin-left: 345px;
    height: 100px;
  }
  #ButtonReset {
    border: 2px solid #2d6bff;
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
    height: fit-content;
  }
  #BSubmit {
    width: 196px;
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
    height: fit-content;
    text-transform: uppercase;
  }

  #FNote {
    padding-top: 16px;
    padding-left: 8px;
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
  }

  .service-request-modal--form-title {
    margin-left: 8px;
  }

  .service-request-modal--form-title {
  }

  .service-request-modal--form-title {
    font-size: 12px;
    font-family: Arial;
    font-weight: bold;
    line-height: 18px;
  }

  .character-count {
    width: 61px;
    margin-left: 575px;
    display: flex;
    justify-content: flex-end;
    margin-top: -2px;
    margin-right: 150px;
    margin-bottom: 20px;
  }
  
  #TextDescription {
    top: 20px;
    position: absolute !important;;
    left: 10px;
  }

  .textarea-container {
    margin-top: 21px;
  }

  #Floor-Design {
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
    height: auto;
    min-height: 40px;
    width: 277px;
    margin-left: 8px;
  }


}

#ButtonReset {
  border: 2px solid #2d6bff;
  font-size: 12px;
  font-family: Arial;
  font-weight: bold;
  line-height: 18px;
  height: fit-content;
}

.button {
  background-color: #2d6bff;
  border: 2px solid #2d6bff;
  cursor: pointer;
  display: inline-block;
  margin: 0 16px 0 0;
  text-align: center;
  color: #fff;
  padding: 10px 0;
  font-weight: bold;
  text-decoration: none;
  font-size: 12px;
}
.button:hover {
  background-color: #2d6bff;
  border: 2px solid #2d6bff;
}
.button:disabled {
  text-transform: uppercase;
  color: #586981;
  font-size: 12px;
  font-family: Arial;
  font-weight: bold;
  line-height: 18px;
  background-color: #9fa9b7;
  border: 2px solid #9fa9b7;
  margin-top: 16px;
}
a.button {
  background-color: #2d6bff;
  border-radius: 5px;
  cursor: pointer;
  border: 4px solid #2d6bff;
  display: inline-block;
  margin: 0 8px 0 0;
  width: 207px;
  text-align: center;
  color: #fff;
  padding: 10px 0;
  font-weight: bold;
  text-decoration: none;
  font-size: 0.75rem;
}
a.button:hover {
  background-color: #2d6bff;
  border: 1px solid #2d6bff;
}
a.button:disabled {
  color: #586981;
  background-color: #9fa9b7;
  border: 4px solid #9fa9b7;
}
.outline-button {
  font-family: inherit;
  font-size: 12px;
  border: 2px solid #2d6bff;
  background-color: transparent;
  color: #021227;
  font-weight: bold;
}
.outline-button:hover {
  border: 2px solid #586981;
  background-color: #fff;
  color: black;
}
.light .bt-spinner {
  width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: transparent;
    border: 3px solid #ddd5d500;
    border-top-color: #03142b;
    border-left-color: #03142b;
    border-bottom-color: #03142b;
    animation: 1s spin linear infinite;
}
.light .spinnerdiv {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-bottom:50vh ;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  bottom: 0;
  right: 0;
  background: #fff;
}
.dark .bt-spinner {
  width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: transparent;
    border: 3px solid #ddd5d500;
    border-top-color: #fff;
    border-left-color: #fff;
    border-bottom-color: #fff;
    animation: 1s spin linear infinite;
}
.dark .spinnerdiv {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-bottom:50vh ;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  bottom: 0;
  right: 0;
  background:  #021125;
}
        
@keyframes spin {
  from {
      transform: rotate(0deg);
  }
  to {
      transform: rotate(360deg);
  }
}  


::-webkit-scrollbar {
  width: 4px;
  display: block !important;
}

::-webkit-scrollbar-thumb {
  background: #586981;
  border-left: 0px solid #ededf0;
}

::-webkit-scrollbar-track {
  background: #ededf0;
}
sup{
  position: inherit !important;
  color: #586981 !important;
  vertical-align: sub  !important;
  font-size: 0.75rem  !important;
  margin-right: 1px  !important;
}

.txtarea {
  width: 627px;
  margin-bottom: 5px;
  margin-left: 7px;
  height: 72px;
  color: #021227;
  /* margin-top: 22px; */
  /* width: 260px; */
  font-size: 12px;
  font-family: Arial;
  font-weight: normal;
  line-height: 18px;
  color: #021227;
  border: 1px solid #ccd2d9;
  padding: 8px;
}

.service-request-modal--form-Note {
  color: blue;
  /* padding-bottom: 36px; */
  font-size: 16px;
}

@media screen and (min-width: 320px) and (max-width: 575px) {
  #FNote {
    padding-top: 16px;
    padding-left: 16px;
    font-size: 14px;
    font-family: Arial;
    font-weight: normal;
    line-height: 20px;
  }

  .service-request-modal--form-title {
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
    margin-left: 16px;
  }

  .Edit-label {
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
  }

  .txtarea {
    margin-top: 24px;
    width: 260px;
    margin-left: 16px;
    height: 72px;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid #586981;
}

.drop-down-container {
  margin-left: 10px;
}

#CharacterCount {
  width: 42px;
  color: #586981;
  margin-top: -7px;
}

.character-count {
  color: #666666;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
  margin-right: 11px;
  margin-left: 235px;
}


#TextDescription {
  top: 38px;
  position: absolute !important;;
  left: 19px;
}

.ButtonsBlock {
  margin-top: 32px;
  margin-bottom: 32px;
  margin-left: 16px;
  display: flex;
  flex-direction: column-reverse;
}

.service-request-modal .button {
  width: 260px;
}

#Floor-Design {
  font-size: 14px;
  font-family: Arial;
  font-weight: normal;
  line-height: 20px;
  height: auto;
  min-height: 40px;
}

}

@media screen and (min-width: 320px) {
  .service-request-modal--form-title {
    width: 166px;
    line-height: 20px;
    height: 16px;
    font-weight: 20px;
  }

  .lightTheme .service-request-modal .drop-down-container {
    flex-direction: column;
   }
}

.service-request-modal--form-title {
  width: 515px;
  line-height: 20px;
  height: 16px;
  font-weight: 20px;
  /* font-size: 14px; */
  font-family: Arial;
  font-weight: bold;
  line-height: 20px;
  color: #021227;
  text-transform: uppercase;
}

.psrhr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 0;
  padding: 0;
  opacity: 1;
}

@media screen and (min-width: 576px) and (max-width: 767px) {

   .service-request-modal 
    .button {
      height: 40px;
      padding: 5px;
      font-size: 14px;
      font-family: Arial;
      font-weight: bold;
      line-height: 20px;
    }
  
  #FNote {
    padding-top: 16px;
    padding-left: 16px;
    font-size: 14px;
    font-family: Arial;
    font-weight: normal;
    line-height: 20px;
  }

  .service-request-modal 
    textarea {
      width: 512px;
      margin-left: 16px;
    }
  
  #CharacterCount {
    width: 42px;
    margin-left: 467px;
    color: #586981;
    margin-top: 5px;
  }

  .service-request-modal--description-top .column {
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
  }

  .service-request-modal--form-title {
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    line-height: 20px;
    margin-left: 11px;
  }
  .Edit-label {
    font-size: 12px;
    font-family: Arial;
    font-weight: normal;
    line-height: 18px;
  }

  .ButtonsBlock {
    padding-left: 210px;
    /* height: 100px; */
    margin-top: 32px;
    margin-bottom: 32px;
    /* float: right; */
    /* width: 70%; */
    margin-left: 32px;
  } 

  #Floor-Design {
    font-size: 14px;
    font-family: Arial;
    font-weight: normal;
    line-height: 20px;
    height: auto;
    min-height: 40px;
    width: 268px;
    height: auto;
  }

}

.service-request-modal .button:disabled {
  text-transform: uppercase;
  color: #586981;
  font-size: 12px;
  font-family: Arial;
  font-weight: bold;
  line-height: 18px;
  background-color: #9fa9b7;
  border: 2px solid #9fa9b7;
  margin-top: 16px;
}

.service-request-modal {
 min-height: 1250px !important;
}

.postspinnerdiv {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* padding-bottom:50vh ; */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  bottom: 0;
  right: 0;
  background: #70686840;
  /* padding-right: 45%;
  padding-top: 45%; */
}

#ButtonReset {
  text-transform: uppercase;
}

#BSubmit {
  text-transform: uppercase;
}

#Floor-Design {
  font-size: 12px;
  font-family: Arial;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0px;
  color: #021227;
  margin-left: 10px;
  width: 255px;
  height: 40px;
  background-color: white;
  border: 5px solid white;
  border-bottom: 1px solid #ccd2d9;
}

#Floor-Design:disabled {
  border-bottom: 0px solid #ccd2d9;
  cursor:default;
}

.contact_number{
  padding-left: 12px;
  padding-top: 10px;
}

#Floor-Design:focus {
  outline:none!important;
  cursor: pointer;
}

#Floor-Design {
  cursor: pointer;
}

.building-address-disabled:disabled {
  border-bottom: 1px solid #ccd2d9 !important;
}

.radio-option-label {
  width: 95% !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;aACW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;CAEC;EACC,4BAA4B;EAC5B,kBAAkB;AACpB;CACC;EACC,uBAAuB;AACzB;CACC;EACC,eAAe;AACjB;CACC;IACG,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,2DAA2D;EAC3D,kBAAkB;EAClB,qBAAqB;;AAEvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;AAEA;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,qBAAqB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;AACA;EACE,yBAAyB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IAGjB,mBAAmB;AACvB;AACA;EACE,YAAY;IACV,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IAGjB,mBAAmB;AACvB;AACA;EACE,gBAAgB;EAChB,mBAAmB;CACpB;GACE;EACD,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,WAAW;IACX,eAAe;IACf,eAAe;IAGf,gCAAgC;IAChC,mBAAmB;IAEnB,0CAA0C;AAC9C;AACA;EACE,kBAAkB;IAChB,MAAM;IACN,UAAU;IACV,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,YAAY;CACf;AACD,yBAAyB,cAAc,EAAE;AACzC;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;AACA;EACE,gBAAgB;EAChB,mBAAmB;CACpB;GACE;EACD,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;AACA;;;EAGE;IACE,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;;IAEjB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;EACA;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;;AAEF;AACA;;EAEE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;EACA;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;;AAGF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;IACT,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;AACtC;AACA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;IACT,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,kCAAkC;AACtC;AACA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,oBAAoB;AACtB;;AAYA;EACE;MAEI,uBAAuB;EAC3B;EACA;MAEI,yBAAyB;EAC7B;AACF;;;AAGA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,SAAS;EACT,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;GACvB;AACH;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;;GAEG;;MAEG,YAAY;MACZ,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,iBAAiB;MACjB,iBAAiB;IACnB;;EAEF;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;MAEI,YAAY;MACZ,iBAAiB;IACnB;;EAEF;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;AAEF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,qBAAqB;EACrB;qBACmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  overflow: hidden;\r\n  letter-spacing: 0.5px;\r\n}\r\nbody > .light{\r\n  background-color: #f6f6f8;\r\n} \r\nbody > .dark{\r\n  background-color: #021125; \r\n} \r\n\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n.grey600 {\r\n  color: #2d6bff;\r\n  line-height: 20px;\r\n  height: 56px;\r\n  margin-left: 16px;\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 20px;\r\n}\r\n.service-request-modal .grey600  {\r\n    width: 454px;\r\n    padding-top: 16px;\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 20px;\r\n    margin-left: 8px;\r\n}\r\n\r\n .service-request-modal {\r\n  overscroll-behavior: contain;\r\n  font-size: 0.75rem;\r\n}\r\n .service-request-modal {\r\n  background-color: white;\r\n}\r\n .service-request-modal--form {\r\n  max-height: 95%;\r\n}\r\n .service-request-modal--form-title {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n    color: #021227;\r\n    text-transform: uppercase;\r\n    margin-left: 8px;\r\n}\r\n.service-request-modal--form-title {\r\n  width: 67%;\r\n}\r\n.Edit-label {\r\n  font-size: 10px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 18px;\r\n  margin-left: 8px;\r\n  color: #586981;\r\n  margin-top: 16px;\r\n}\r\n.service-request-modal--form.mt-2 {\r\n  margin-top: 16px;\r\n}\r\n.drop-down-container select {\r\n  margin-left: 8px;\r\n  width: 255px;\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  padding-top: 10px;\r\n  border-bottom: 1px solid #ccd2d9 !important;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding-bottom: 12px;\r\n  border: none;\r\n  color: #586981;\r\n  height: 40px;\r\n  outline: none;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n.topshow {\r\n  padding-top: 30px;\r\n}\r\nli{\r\n  list-style-type: none;\r\n}\r\n.Radio-buttons-Elevator {\r\n  cursor: pointer;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n#ElevatorB {\r\n  margin-bottom: 16px;\r\n}\r\n#ElevatorB {\r\n  margin-left: -13px;\r\n}\r\n#ListHeight {\r\n  min-height: 0px !important;\r\n}\r\n.radio-service input {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  visibility: hidden;\r\n}\r\n.radio-service input:focus + label {\r\n  background: #eef;\r\n}\r\n.radio-service input:focus + label .checker {\r\n  border-color: #34cb81;\r\n}\r\n.radio-service input:checked + label .checker {\r\n  box-shadow: inset 0 0 0 4px #34cb81;\r\n}\r\n.radio-service label {\r\n  color: #000;\r\n  display: -webkit-box;\r\n  align-items: center;\r\n  border-radius: 14px;\r\n  margin-top: 8px;\r\n  margin-left: 6px;\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 18px;\r\n  -webkit-text-size-adjust: 100%;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n.radio-service label:hover .checker {\r\n  box-shadow: inset 0 0 0 4px #34cb81;\r\n}\r\n.radio-service .checker {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  margin-right: 7px;\r\n  margin-top: 2px;\r\n  box-shadow: inset 0 0 0 1px black;\r\n  transition: box-shadow 0.3s ease;\r\n}\r\n.textarea-container {\r\n  position: relative;\r\n}\r\n\r\n.character-count-color {\r\n  color: #9fa9b7;\r\n}\r\n\r\n.textarea-container {\r\n  position: relative;\r\n}\r\n\r\n.radiofit{\r\n  width: 100%;\r\n  height: 24px;\r\n}\r\noption{\r\n  background-color: #041e42;\r\n  color: white;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 8px 0 8px 8px;\r\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n  font-size: inherit;\r\n  letter-spacing: 0.5px;\r\n\r\n}\r\n.ddlstyle {\r\n  width: 272px;\r\n}\r\n.ddlstyle option{\r\n  width: 272px;\r\n}\r\n.ddlcontainer{\r\n\r\n}\r\nselect {\r\n  width: 270px;\r\n  margin: 20px;\r\n}\r\noption {\r\n  max-width: 100px;\r\n}\r\n.button:disabled {\r\n  text-transform: uppercase;\r\n  color: #586981;\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 18px;\r\n  background-color: #9fa9b7;\r\n  border: 2px solid #9fa9b7;\r\n  margin-top: 16px;\r\n}\r\n.btndiv{\r\n  margin-bottom: 0.8rem;\r\n    /* float: right; */\r\n    /* width: 70%; */\r\n    margin-left: 345px;\r\n    height: 100px;\r\n}\r\n.btnreset{\r\n  border: 2px solid #2d6bff;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n    height: -webkit-fit-content;\r\n    height: -moz-fit-content;\r\n    height: fit-content;\r\n}\r\n.btnsubmit{\r\n  width: 196px;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n    height: -webkit-fit-content;\r\n    height: -moz-fit-content;\r\n    height: fit-content;\r\n}\r\n.ButtonsBlock {\r\n  margin-top: 32px;\r\n  margin-bottom: 32px;\r\n /* float: right;\r\n  */\r\n  margin-left: 16px;\r\n}\r\n.ButtonsBlock .button {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n.ButtonsBlock .button .button {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n#ButtonReset {\r\n  /* width: 260px; */\r\n  /* margin-top: 36px; */\r\n  border: 2px solid #2d6bff;\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 20px;\r\n  /* height: 40px; */\r\n  margin-top: 16px;\r\n  padding: 5px;\r\n  height: 32px;\r\n}\r\n\r\n#BSubmit {\r\n  width: 260px;\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 20px;\r\n  height: fit-content;\r\n  padding: 5px;\r\n  height: 32px;\r\n  /* margin-bottom: -64px; */\r\n}\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 8;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n.popup_inner {\r\n  position: absolute;\r\n  left: 25%;\r\n  right: 25%;\r\n  top: 25%;\r\n  bottom: 25%;\r\n  margin: auto;\r\n  background: white;\r\n}\r\n.psrmodal{\r\n  display: block;\r\n    width: auto;\r\n    position: fixed;\r\n    z-index: 8;\r\n    left: 50%;\r\n    top: 50%;\r\n    color: #000;\r\n    max-width: 100%;\r\n    max-height: 98%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    background: #f2f2f2;\r\n    -webkit-box-shadow: 0 0 60px 10px rgb(0 0 0 / 30%);\r\n    box-shadow: 0 0 60px 10px rgb(0 0 0 / 30%);\r\n}\r\n.psrmodal .close       { \r\n  position: absolute;\r\n    top: 0;\r\n    right: 9px;\r\n    transition: all 200ms;\r\n    font-size: 30px;\r\n    /* font-weight: bold; */\r\n    text-decoration: none;\r\n    color: #787373;\r\n    cursor: pointer;\r\n    z-index: 999;\r\n }\r\n.psrmodal .close:hover { color: #041e42; }\r\n#modal-root {\r\n  position: relative;\r\n  z-index: 999;\r\n}\r\n.dark .container-fluid{\r\n  background-color: #021125;\r\n}\r\n\r\n.light .container-fluid{\r\n  background-color: #f6f6f8;\r\n}\r\n\r\n@media screen and (min-width: 576px) and (max-width: 767px) {\r\n.ButtonsBlock {\r\n  margin-top: 32px;\r\n  margin-bottom: 32px;\r\n /* float: right;\r\n  */\r\n  margin-left: 16px;\r\n}\r\n.ButtonsBlock .button {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n.ButtonsBlock .button .button {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n#ButtonReset {\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 20px;\r\n  height: fit-content;\r\n}\r\n#TextDescription {\r\n  margin-left: 19px;\r\n  top: -74px;\r\n}\r\n#BSubmit {\r\n  width: 216px;\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 20px;\r\n  height: fit-content;\r\n}\r\n\r\n#FNote {\r\n  padding-top: 16px;\r\n  padding-left: 16px;\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 20px;\r\n}\r\n\r\n.service-request-modal--form-title {\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 20px;\r\n  margin-left: 16px;\r\n}\r\n.textarea-container {\r\n  margin-top: 21px;\r\n  margin-left: -7px;\r\n}\r\n\r\n}\r\n@media screen and (min-width: 768px) and (max-width: 991px) {\r\n\r\n\r\n  .ButtonsBlock {\r\n    /* margin-top: 2.8rem; */\r\n    margin-bottom: 36px;\r\n    /* float: right; */\r\n    /* width: 70%; */\r\n    position: relative;\r\n    /* padding-left: -74px; */\r\n    margin-left: 345px;\r\n  }\r\n  #BSubmit {\r\n    width: 216px;\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n    height: fit-content;\r\n  }\r\n\r\n  #ButtonReset {\r\n    border: 2px solid #2d6bff;\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n    height: fit-content;\r\n  }\r\n\r\n  #FNote {\r\n    padding-top: 16px;\r\n    padding-left: 16px;\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .Edit-label {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n}\r\n\r\n.character-count {\r\n  width: 61px;\r\n  margin-left: 575px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: -2px;\r\n  margin-right: 150px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n#TextDescription {\r\n  top: 20px;\r\n  position: absolute !important;;\r\n  left: 10px;\r\n}\r\n\r\n.textarea-container {\r\n  margin-top: 21px;\r\n}\r\n\r\n#Floor-Design {\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 20px;\r\n  height: auto;\r\n  min-height: 40px;\r\n  width: 224px;\r\n}\r\n\r\n}\r\n@media screen and (min-width: 992px) and (max-width: 1200px) {\r\n  .ButtonsBlockFrance {\r\n    margin-top: 32px;\r\n    margin-bottom: 32px;\r\n    /* float: right; */\r\n    width: 100%;\r\n    margin-left: 271px;\r\n  }\r\n  .ButtonsBlock {\r\n    margin-bottom: 32px;\r\n  }\r\n  #ButtonReset {\r\n    border: 2px solid #2d6bff;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n\r\n    height: fit-content;\r\n  }\r\n  #BSubmit {\r\n    width: 196px;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n    height: fit-content;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    margin-left: 8px;\r\n  }\r\n\r\n  #FNote {\r\n    padding-top: 16px;\r\n    padding-left: 8px;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .Edit-label {\r\n    margin-left: 8px;\r\n    font-size: 10px;\r\n  }\r\n\r\n  #Floor-Design {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n    margin-left: 8px;\r\n    height: auto;\r\n    min-height: 40px;\r\n    width: 224px;\r\n  }\r\n\r\n}\r\n@media screen and (min-width: 1200px) {\r\n\r\n  .ButtonsBlock {\r\n    /* margin-top: .8rem; */\r\n    margin-bottom: 0.8rem;\r\n    /* float: right; */\r\n    /* width: 70%; */\r\n    margin-left: 345px;\r\n    height: 100px;\r\n  }\r\n  #ButtonReset {\r\n    border: 2px solid #2d6bff;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n    height: fit-content;\r\n  }\r\n  #BSubmit {\r\n    width: 196px;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n    height: fit-content;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  #FNote {\r\n    padding-top: 16px;\r\n    padding-left: 8px;\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    margin-left: 8px;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .character-count {\r\n    width: 61px;\r\n    margin-left: 575px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: -2px;\r\n    margin-right: 150px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  #TextDescription {\r\n    top: 20px;\r\n    position: absolute !important;;\r\n    left: 10px;\r\n  }\r\n\r\n  .textarea-container {\r\n    margin-top: 21px;\r\n  }\r\n\r\n  #Floor-Design {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n    height: auto;\r\n    min-height: 40px;\r\n    width: 277px;\r\n    margin-left: 8px;\r\n  }\r\n\r\n\r\n}\r\n\r\n#ButtonReset {\r\n  border: 2px solid #2d6bff;\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 18px;\r\n  height: fit-content;\r\n}\r\n\r\n.button {\r\n  background-color: #2d6bff;\r\n  border: 2px solid #2d6bff;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  margin: 0 16px 0 0;\r\n  text-align: center;\r\n  color: #fff;\r\n  padding: 10px 0;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  font-size: 12px;\r\n}\r\n.button:hover {\r\n  background-color: #2d6bff;\r\n  border: 2px solid #2d6bff;\r\n}\r\n.button:disabled {\r\n  text-transform: uppercase;\r\n  color: #586981;\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 18px;\r\n  background-color: #9fa9b7;\r\n  border: 2px solid #9fa9b7;\r\n  margin-top: 16px;\r\n}\r\na.button {\r\n  background-color: #2d6bff;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  border: 4px solid #2d6bff;\r\n  display: inline-block;\r\n  margin: 0 8px 0 0;\r\n  width: 207px;\r\n  text-align: center;\r\n  color: #fff;\r\n  padding: 10px 0;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  font-size: 0.75rem;\r\n}\r\na.button:hover {\r\n  background-color: #2d6bff;\r\n  border: 1px solid #2d6bff;\r\n}\r\na.button:disabled {\r\n  color: #586981;\r\n  background-color: #9fa9b7;\r\n  border: 4px solid #9fa9b7;\r\n}\r\n.outline-button {\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  border: 2px solid #2d6bff;\r\n  background-color: transparent;\r\n  color: #021227;\r\n  font-weight: bold;\r\n}\r\n.outline-button:hover {\r\n  border: 2px solid #586981;\r\n  background-color: #fff;\r\n  color: black;\r\n}\r\n.light .bt-spinner {\r\n  width: 24px;\r\n    height: 24px;\r\n    border-radius: 50%;\r\n    background-color: transparent;\r\n    border: 3px solid #ddd5d500;\r\n    border-top-color: #03142b;\r\n    border-left-color: #03142b;\r\n    border-bottom-color: #03142b;\r\n    animation: 1s spin linear infinite;\r\n}\r\n.light .spinnerdiv {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding-bottom:50vh ;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 100;\r\n  bottom: 0;\r\n  right: 0;\r\n  background: #fff;\r\n}\r\n.dark .bt-spinner {\r\n  width: 24px;\r\n    height: 24px;\r\n    border-radius: 50%;\r\n    background-color: transparent;\r\n    border: 3px solid #ddd5d500;\r\n    border-top-color: #fff;\r\n    border-left-color: #fff;\r\n    border-bottom-color: #fff;\r\n    animation: 1s spin linear infinite;\r\n}\r\n.dark .spinnerdiv {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding-bottom:50vh ;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 100;\r\n  bottom: 0;\r\n  right: 0;\r\n  background:  #021125;\r\n}\r\n@-webkit-keyframes spin {\r\n  from {\r\n      -webkit-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n  }\r\n  to {\r\n      -webkit-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n  }\r\n}\r\n        \r\n@keyframes spin {\r\n  from {\r\n      -webkit-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n  }\r\n  to {\r\n      -webkit-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n  }\r\n}  \r\n\r\n\r\n::-webkit-scrollbar {\r\n  width: 4px;\r\n  display: block !important;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #586981;\r\n  border-left: 0px solid #ededf0;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #ededf0;\r\n}\r\nsup{\r\n  position: inherit !important;\r\n  color: #586981 !important;\r\n  vertical-align: sub  !important;\r\n  font-size: 0.75rem  !important;\r\n  margin-right: 1px  !important;\r\n}\r\n\r\n.txtarea {\r\n  width: 627px;\r\n  margin-bottom: 5px;\r\n  margin-left: 7px;\r\n  height: 72px;\r\n  color: #021227;\r\n  /* margin-top: 22px; */\r\n  /* width: 260px; */\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 18px;\r\n  color: #021227;\r\n  border: 1px solid #ccd2d9;\r\n  padding: 8px;\r\n}\r\n\r\n.service-request-modal--form-Note {\r\n  color: blue;\r\n  /* padding-bottom: 36px; */\r\n  font-size: 16px;\r\n}\r\n\r\n@media screen and (min-width: 320px) and (max-width: 575px) {\r\n  #FNote {\r\n    padding-top: 16px;\r\n    padding-left: 16px;\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n    margin-left: 16px;\r\n  }\r\n\r\n  .Edit-label {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .txtarea {\r\n    margin-top: 24px;\r\n    width: 260px;\r\n    margin-left: 16px;\r\n    height: 72px;\r\n    font-size: 14px;\r\n    line-height: 18px;\r\n    border: 1px solid #586981;\r\n}\r\n\r\n.drop-down-container {\r\n  margin-left: 10px;\r\n}\r\n\r\n#CharacterCount {\r\n  width: 42px;\r\n  color: #586981;\r\n  margin-top: -7px;\r\n}\r\n\r\n.character-count {\r\n  color: #666666;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 0.75rem;\r\n  margin-right: 11px;\r\n  margin-left: 235px;\r\n}\r\n\r\n\r\n#TextDescription {\r\n  top: 38px;\r\n  position: absolute !important;;\r\n  left: 19px;\r\n}\r\n\r\n.ButtonsBlock {\r\n  margin-top: 32px;\r\n  margin-bottom: 32px;\r\n  margin-left: 16px;\r\n  display: flex;\r\n  flex-direction: column-reverse;\r\n}\r\n\r\n.service-request-modal .button {\r\n  width: 260px;\r\n}\r\n\r\n#Floor-Design {\r\n  font-size: 14px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 20px;\r\n  height: auto;\r\n  min-height: 40px;\r\n}\r\n\r\n}\r\n\r\n@media screen and (min-width: 320px) {\r\n  .service-request-modal--form-title {\r\n    width: 166px;\r\n    line-height: 20px;\r\n    height: 16px;\r\n    font-weight: 20px;\r\n  }\r\n\r\n  .lightTheme .service-request-modal .drop-down-container {\r\n    flex-direction: column;\r\n   }\r\n}\r\n\r\n.service-request-modal--form-title {\r\n  width: 515px;\r\n  line-height: 20px;\r\n  height: 16px;\r\n  font-weight: 20px;\r\n  /* font-size: 14px; */\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 20px;\r\n  color: #021227;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.psrhr {\r\n  display: block;\r\n  height: 1px;\r\n  border: 0;\r\n  border-top: 1px solid #ccc;\r\n  margin: 0;\r\n  padding: 0;\r\n  opacity: 1;\r\n}\r\n\r\n@media screen and (min-width: 576px) and (max-width: 767px) {\r\n\r\n   .service-request-modal \r\n    .button {\r\n      height: 40px;\r\n      padding: 5px;\r\n      font-size: 14px;\r\n      font-family: Arial;\r\n      font-weight: bold;\r\n      line-height: 20px;\r\n    }\r\n  \r\n  #FNote {\r\n    padding-top: 16px;\r\n    padding-left: 16px;\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .service-request-modal \r\n    textarea {\r\n      width: 512px;\r\n      margin-left: 16px;\r\n    }\r\n  \r\n  #CharacterCount {\r\n    width: 42px;\r\n    margin-left: 467px;\r\n    color: #586981;\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .service-request-modal--description-top .column {\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .service-request-modal--form-title {\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: bold;\r\n    line-height: 20px;\r\n    margin-left: 11px;\r\n  }\r\n  .Edit-label {\r\n    font-size: 12px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 18px;\r\n  }\r\n\r\n  .ButtonsBlock {\r\n    padding-left: 210px;\r\n    /* height: 100px; */\r\n    margin-top: 32px;\r\n    margin-bottom: 32px;\r\n    /* float: right; */\r\n    /* width: 70%; */\r\n    margin-left: 32px;\r\n  } \r\n\r\n  #Floor-Design {\r\n    font-size: 14px;\r\n    font-family: Arial;\r\n    font-weight: normal;\r\n    line-height: 20px;\r\n    height: auto;\r\n    min-height: 40px;\r\n    width: 268px;\r\n    height: auto;\r\n  }\r\n\r\n}\r\n\r\n.service-request-modal .button:disabled {\r\n  text-transform: uppercase;\r\n  color: #586981;\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: bold;\r\n  line-height: 18px;\r\n  background-color: #9fa9b7;\r\n  border: 2px solid #9fa9b7;\r\n  margin-top: 16px;\r\n}\r\n\r\n.service-request-modal {\r\n min-height: 1250px !important;\r\n}\r\n\r\n.postspinnerdiv {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  /* padding-bottom:50vh ; */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 100;\r\n  bottom: 0;\r\n  right: 0;\r\n  background: #70686840;\r\n  /* padding-right: 45%;\r\n  padding-top: 45%; */\r\n}\r\n\r\n#ButtonReset {\r\n  text-transform: uppercase;\r\n}\r\n\r\n#BSubmit {\r\n  text-transform: uppercase;\r\n}\r\n\r\n#Floor-Design {\r\n  font-size: 12px;\r\n  font-family: Arial;\r\n  font-weight: normal;\r\n  line-height: 18px;\r\n  letter-spacing: 0px;\r\n  color: #021227;\r\n  margin-left: 10px;\r\n  width: 255px;\r\n  height: 40px;\r\n  background-color: white;\r\n  border: 5px solid white;\r\n  border-bottom: 1px solid #ccd2d9;\r\n}\r\n\r\n#Floor-Design:disabled {\r\n  border-bottom: 0px solid #ccd2d9;\r\n  cursor:default;\r\n}\r\n\r\n.contact_number{\r\n  padding-left: 12px;\r\n  padding-top: 10px;\r\n}\r\n\r\n#Floor-Design:focus {\r\n  outline:none!important;\r\n  cursor: pointer;\r\n}\r\n\r\n#Floor-Design {\r\n  cursor: pointer;\r\n}\r\n\r\n.building-address-disabled:disabled {\r\n  border-bottom: 1px solid #ccd2d9 !important;\r\n}\r\n\r\n.radio-option-label {\r\n  width: 95% !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
